<script setup lang="ts" generic="T extends Record<string, unknown>">
import { Plus, Trash2 } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

defineProps<{
  title: string
  items: T[]
}>()

const emit = defineEmits<{
  add: []
  remove: [index: number]
}>()
</script>

<template>
  <Card>
    <CardHeader>
      <div class="flex items-center justify-between">
        <CardTitle class="text-base">{{ title }}</CardTitle>
        <Button type="button" variant="outline" size="sm" @click="emit('add')">
          <Plus class="mr-1 size-4" />
          Add
        </Button>
      </div>
    </CardHeader>
    <CardContent class="space-y-4">
      <div v-if="items.length === 0" class="text-muted-foreground py-4 text-center text-sm">
        No {{ title.toLowerCase() }} added
      </div>
      <div v-for="(item, index) in items" :key="index" class="border-border rounded-md border p-4">
        <div class="mb-3 flex items-center justify-between">
          <slot name="header" :item="item" :index="index" />
          <Button type="button" variant="ghost" size="sm" class="text-destructive h-6 px-2 ml-auto" @click="emit('remove', index)">
            <Trash2 class="size-3" />
          </Button>
        </div>
        <slot :item="item" :index="index" />
      </div>
    </CardContent>
  </Card>
</template>
